import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { setSendSaleInvoiceToCustomer } from '../services/setSendSaleInvoiceToCustomer';


export const sendSaleInvoiceToCustomer = createAsyncThunk(
  'saleInvoices/sendSaleInvoiceToCustomer',
  async (params, { getState, dispatch }) => {
    console.log('params', params);
    const { saleInvoiceId } = params;

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await setSendSaleInvoiceToCustomer(
      selectedProjectId,
      saleInvoiceId
    );
    console.log('response', response);
    return response;
  }
);
